var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.animation)?_c('lottie',{attrs:{"options":_vm.animationOptions},on:{"animCreated":_vm.handleAnimation}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }